import clsx from 'clsx';
import { FC } from 'react';
import Rectangle1 from '../../assets/category/rectangle1.png';
import Rectangle2 from '../../assets/category/rectangle2.png';
import Rectangle3 from '../../assets/category/rectangle3.png';
import Square1 from '../../assets/category/square1.png';
import Square2 from '../../assets/category/square2.png';
import Square3 from '../../assets/category/square3.png';
import Square4 from '../../assets/category/square4.png';
import Square5 from '../../assets/category/square5.png';
import { LinkButton } from '../../components/buttons/LinkButton.client';
import { Link } from '../../components/Link.client';
import { SubHeading } from '../../components/SubHeading.client';

interface Props {
  showHalf?: boolean;
}

export const Categories: FC<Props> = ({ showHalf }) => (
  <section className="my-16">
    <div className="wrapper">
      <div className="mb-3">
        <SubHeading title="CATEGORY" subTitle="カテゴリー" />
      </div>
      <div className="flex flex-wrap justify-center gap-4 md:grid md:grid-cols-10">
        <CategoryItem handle="ペット仏壇" className="w-[calc(50%-0.5rem)] md:w-full" />
        <CategoryItem handle="ペット位牌" className="w-[calc(50%-0.5rem)] md:w-full" />
        <CategoryItem handle="ペット仏具" className="w-[calc(50%-0.5rem)] md:w-full" />
        <CategoryItem handle="骨壺・骨袋" className="w-[calc(50%-0.5rem)] md:w-full" />
        <CategoryItem handle="メモリアルグッズ" className="w-[calc(50%-0.5rem)] md:w-full" />
      </div>
      {showHalf || (
        <div className="mt-4 grid grid-cols-2 gap-4 md:grid-cols-4">
          <CategoryItem handle="仏具セット" />
          <CategoryItem handle="線香・ろうそく・灯" />
        </div>
      )}
      <div className="mt-8 flex justify-center">
        <Link route="categories">
          <LinkButton title="全てのカテゴリー" subTitle="ALL" />
        </Link>
      </div>
    </div>
  </section>
);

interface CategoryItemProps {
  handle: string;
  className?: string;
}

const CategoryItem: FC<CategoryItemProps> = ({ handle, className }) => (
  <div className={clsx('col-span-2 bg-thinGray', className)}>
    <Link route="category" handle={handle}>
      <div
        className={clsx(
          'relative text-right',
          ['ペット仏壇', 'ペット位牌', 'ペット仏具', '骨壺・骨袋', 'メモリアルグッズ'].includes(
            handle,
          ) && 'pt-6',
        )}
      >
        <CategoryImage handle={handle} />
        <CategoryText handle={handle} />
      </div>
    </Link>
  </div>
);

const CategoryImage: FC<{ handle: string }> = ({ handle }) => {
  switch (handle) {
    case 'ペット仏壇':
      return <img src={Square1} alt={handle} />;
    case 'ペット位牌':
      return <img src={Square2} alt={handle} />;
    case 'ペット仏具':
      return <img src={Square3} alt={handle} />;
    case '骨壺・骨袋':
      return <img src={Square4} alt={handle} />;
    case 'メモリアルグッズ':
      return <img src={Square5} alt={handle} />;
    case '仏具セット':
      return (
        <img src={Rectangle1} alt={handle} className="h-72 object-cover object-left md:h-[206px]" />
      );
    case 'オーダーメイドグッズ':
      return (
        <img src={Rectangle2} alt={handle} className="h-72 object-cover object-left md:h-[206px]" />
      );
    case '線香・ろうそく・灯':
      return (
        <img src={Rectangle3} alt={handle} className="h-72 object-cover object-left md:h-[206px]" />
      );
    default:
      return null;
  }
};

const CategoryText: FC<{ handle: string }> = ({ handle }) => {
  switch (handle) {
    case 'ペット仏壇':
    case 'ペット位牌':
    case 'ペット仏具':
    case '骨壺・骨袋':
    case 'メモリアルグッズ':
      return (
        <div className="absolute top-3 w-full px-4">
          <p className="truncate text-[15px] md:text-[17px]">{handle}</p>
        </div>
      );
    case '仏具セット':
      return (
        <div className="px-6 pt-3 pb-9 md:absolute md:top-1/2 md:right-5 md:w-56 md:-translate-y-1/2 md:transform md:px-0 md:py-0">
          <p className="font-outfit text-xs">SET ITEM</p>
          <p className="mb-3 text-[17px] font-bold">{handle}</p>
          <p className="text-sm">
            初めての事でペット供養に何が必要なのか分からない…という方におすすめの仏具セットです。
          </p>
        </div>
      );
    case 'オーダーメイドグッズ':
      return (
        <div className="px-6 pt-3 pb-9 md:absolute md:top-1/2 md:right-5 md:w-56 md:-translate-y-1/2 md:transform md:px-0 md:py-0">
          <p className="font-outfit text-xs">ORDER MADE</p>
          <p className="mb-3 text-[17px] font-bold">{handle}</p>
          <p className="text-sm">
            ペットの写真やお名前をプリントして、世界に一つだけのオリジナルグッズをお作りいただけます。
          </p>
        </div>
      );
    case '線香・ろうそく・灯':
      return (
        <div className="px-6 pt-3 pb-9 md:absolute md:top-1/2 md:right-5 md:w-56 md:-translate-y-1/2 md:transform md:px-0 md:py-0">
          <p className="font-outfit text-xs">CANDLE / LIGHT</p>
          <p className="mb-3 text-[17px] font-bold">{handle}</p>
          <p className="text-sm">
            暖かくやわらかな明りのLEDライトや、優しい香のお線香で癒しの空間に。
          </p>
        </div>
      );
    default:
      return null;
  }
};
